var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"btn-filter",class:{
    active: _vm.isActive,
    'btn-filter--unaccepted': _vm.isUnaccepted,
  },attrs:{"variant":"light"},on:{"click":_vm.onClick}},[(_vm.icon)?_c('i',{staticClass:"fas",class:_vm.icon}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.text))]),(!_vm.noCount)?_c('b-badge',{staticClass:"ml-2",attrs:{"variant":"primary","pill":""}},[_vm._v(" "+_vm._s(_vm.count)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }